import * as React from "react";

import { cn } from "@/lib/utils";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

/**
 * Estándar del core: no se redimensiona a mano. Crece con el texto (`field-sizing: content`)
 * hasta un alto máximo y de ahí hace scroll por dentro. Los editores grandes (`rows` > 8,
 * plantillas y similares) conservan su alto fijo con scroll. Un `className` con `max-h-*` o
 * `h-*` lo sobrescribe.
 */
const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({ className, ...props }, ref) => {
  const grande = Number(props.rows ?? 0) > 8;
  return (
    <textarea
      className={cn(
        "flex min-h-[80px] w-full resize-none overflow-y-auto rounded-md border border-control-border bg-background px-3 py-2.5 text-sm ring-offset-background transition-colors placeholder:font-normal placeholder:text-foreground/40 focus-visible:border-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/15 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-50",
        !grande && "max-h-60 [field-sizing:content]",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
